import { createSlug } from '@brainpool/utils';
import { Case } from '../types/Case';
import { WorkflowStatus } from '../types/WorkflowState';
import { completedStatuses } from '../components/ProjectsTable/types';

export const goToPage = (page: string, navigate: (path: string) => void) => {
  navigate(page);
};

export const handleGoToProject = (
  id: string,
  name: string,
  page: string,
  navigate: (path: string) => void
) => {
  if (name) {
    const slug = createSlug(name);
    const newId = id.replace('Case_', '');
    goToPage(`/${page}/${slug}?id=${newId}`, navigate);
  }
};

export const filterProjectsByOwnership = (projects: Partial<Case>[]) => {
  const ownedProjectIDs: string[] = [];
  const ownedProjects: Partial<Case>[] = [];
  const nonOwnedProjects: Partial<Case>[] = [];

  if (!projects || projects?.length === 0)
    return { ownedProjects, ownedProjectIDs, nonOwnedProjects };

  projects.forEach(project => {
    if (project.role === 'Owner') {
      ownedProjects.push(project);
      if (project.id) {
        ownedProjectIDs.push(project.id);
      }
    } else {
      nonOwnedProjects.push(project);
    }
  });
  return { ownedProjects, ownedProjectIDs, nonOwnedProjects };
};

export const getGetWorkflowStatus = (status: WorkflowStatus | null): boolean => {
  return status ? completedStatuses.includes(status) : false;
};
